<template>
  <div class="fill-width comp-wizard-content">
    <div>
      <span class="h1"
            role="heading"
            aria-level="1"
      >{{ $t('wizard.headerTwo') }}</span><br>
      <p>{{ $t('wizard.ingressChekcboxes') }}</p>
    </div>
    <sprcheckbox v-for="(skill, index) in $store.state.profilePersonalSkills"
                 :key="'wizard_2_' + index"
                 :value="skill.id"
                 :title="$t('skills.' + skill.text)"
                 click-event="box-selected"
                 :collection="$store.state.wizardModel.personalSkills"
                 @box-selected="handleCheckbox"
    />
  </div>
</template>

<script>
  import sprcheckbox from '../SPRCheckbox.vue'

  export default {
    name: 'WizardTwo',
    components: { sprcheckbox },
    data () {
      return {
        selected: new Set(),
        skills: []
      }
    },
    methods: {
      handleCheckbox: function (value, isChecked) {
        if (isChecked) {
          this.selected.add(value)
        } else {
          this.selected.delete(value)
        }
        var arr = [...this.selected]

        this.$store.commit('setWizardSkills', arr)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~@/assets/scss/_variables.scss';
  @import '~@/assets/scss/_wizard.scss';
</style>
